export default {
  NoChange: -1000,
  ValidationException: 2000000001
};
